module.exports = __webpack_public_path__ + "img/client5.4afca886.png";